import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ExportExcelDialog from '_c/ExportExcelDialog';
export default {
  components: _defineProperty({}, ExportExcelDialog.name, ExportExcelDialog),
  data: function data() {
    return {
      params: JSON.parse(sessionStorage.getItem('payroll.wage.list.params')),
      columns: {},
      tableData: [],
      loading: false,
      page: {
        total: 0,
        page: 1,
        page_size: 20
      }
    };
  },
  created: function created() {
    var _this = this;
    // sessionStorage.removeItem('payroll.wage.list.params')
    // if (!this.params) {
    //   this.$router.push('/payroll/wage')
    //   return
    // }
    this.loading = true;
    // 获取导出的全量数据
    Promise.all([this.getColumns(), this.getTableData()]).then(function (res) {
      var _res = _slicedToArray(res, 2),
        res1 = _res[0],
        res2 = _res[1];
      _this.columns = res1.data;
      _this.tableData = res2.data.list;
      _this.page.total = res2.data.count;
      _this.$nextTick(function () {
        _this.$refs.Eltable.doLayout();
      });
    }).finally(function () {
      _this.loading = false;
    });
  },
  methods: {
    /**
     * 获取表格列
     */
    getColumns: function getColumns() {
      return this.$http({
        url: '/web/payroll_sub_project_staff/getPaySheetCombinedHeader',
        data: {
          is_combine: this.params.is_combine,
          sub_project_id: this.params.sub_project_id
        }
      });
    },
    /**
     * 获取表格数据
     */
    getTableData: function getTableData() {
      return this.$http({
        url: '/web/payroll_sub_project_staff/getPaySheetCombinedList',
        data: {
          is_combine: this.params.is_combine,
          sub_project_id: this.params.sub_project_id,
          page: this.page.page,
          page_size: this.page.page_size
        }
      });
    },
    /**
     * 刷新表格数据
     */
    reloadTableData: function reloadTableData() {
      var _this2 = this;
      this.loading = true;
      this.getTableData().then(function (res) {
        _this2.tableData = res.data.list;
        _this2.page.total = res.data.count;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    /**
     * 导出事件
     */
    handleExport: function handleExport() {
      var _this$params = this.params,
        relation_type = _this$params.relation_type,
        relation_id = _this$params.relation_id,
        sub_project_id = _this$params.sub_project_id,
        is_combine = _this$params.is_combine;
      var params = {
        relation_type: relation_type,
        relation_id: relation_id
      };
      var data = {
        sub_project_id: sub_project_id,
        is_combine: is_combine
      };
      this.$refs.ExportExcelDialog.init(params, data);
    },
    /**
     * pageSize 改变时会触发
     */
    handleSizeChange: function handleSizeChange() {
      this.reloadTableData();
    },
    /**
     * currentPage 改变时会触发
     */
    handleCurrentChange: function handleCurrentChange() {
      this.reloadTableData();
    }
  }
};